import prodConfig from './config/env-configs/prod.config';
import devConfig from './config/env-configs/dev.config';
import developmentConfig from './config/env-configs/development.config';

const configMap = {
  development: developmentConfig,
  prod: prodConfig,
  dev: devConfig,
};

const config = configMap[process.env.REACT_APP_STAGE] || developmentConfig;
export default config;
